(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("repluggable"), require("lodash"), require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["repluggable", "lodash", "react", "reactDOM"], factory);
	else if(typeof exports === 'object')
		exports["EditorPlatformHostIntegration"] = factory(require("repluggable"), require("lodash"), require("react"), require("react-dom"));
	else
		root["EditorPlatformHostIntegration"] = factory(root["repluggable"], root["_"], root["React"], root["ReactDOM"]);
})((typeof self !== 'undefined' ? self : this), (__WEBPACK_EXTERNAL_MODULE__96966__, __WEBPACK_EXTERNAL_MODULE__3014__, __WEBPACK_EXTERNAL_MODULE__96422__, __WEBPACK_EXTERNAL_MODULE__6256__) => {
return 